import {observer} from "mobx-react";
import * as React from "react";
import {computed, observable} from "mobx";
import { QuizQuestion} from "components/quiz/QuizQuestion";
import { RadioQuestionOption} from "components/quiz/RadioQuestionOption";
import {UserAnswer} from "components/quiz/UserAnswer";
import {isEmpty} from "../../utils";


interface IRadioQuestion_Props {
  userAnswer:UserAnswer;
  answerLocked:boolean;
}

@observer
export class RadioQuestion extends React.Component<IRadioQuestion_Props> {

  @observable wrongAnswer = '';

  handleQuestionAnswered = (answerIndex?, wrongAnswerCallback?) => {
    this.handleClearAnswerFeedback();
    if (answerIndex !== undefined && answerIndex != null) {
      if(this.props.userAnswer.step.hasCorrectAnswer) {
        if (this.props.userAnswer.step.correctAnswer != answerIndex) {
          this.wrongAnswer = "Incorrect answer!";
          wrongAnswerCallback();
          this.props.userAnswer.answerValue = '';
          return;
        } else {
          this.wrongAnswer = "Correct answer!";
        }
      }
    }
    this.props.userAnswer.answerValue = answerIndex;
  }

  handleClearAnswerFeedback = () => {
    this.wrongAnswer = "";
  }

  @computed
  get correctAnswerIsSelected() {
    return (
        (!this.props.userAnswer.step.hasCorrectAnswer && !isEmpty(this.props.userAnswer.answerValue)) ||
        (this.props.userAnswer.step.hasCorrectAnswer && this.props.userAnswer.step.correctAnswer === this.props.userAnswer.answerValue)
    )
  }

  render() {
    const { userAnswer } = this.props;

    return (
      <QuizQuestion>
        <p className={"visuallyhidden"} aria-live={"assertive"}>{this.wrongAnswer}</p>
        <div role="radiogroup">
          {userAnswer.step.answers.map(
            (answer, index) =>
              <RadioQuestionOption
                  correctAnswerIsSelected={this.correctAnswerIsSelected}
                  answerLocked={this.props.answerLocked}
                onQuestionAnswered={this.handleQuestionAnswered}
                onClearAnswerFeedback={this.handleClearAnswerFeedback}
                key={"answer-" + index}
                index={index}
                selectedIndex={this.props.userAnswer.answerValue}>{answer.label}</RadioQuestionOption>
            )
          }
        </div>
      </QuizQuestion>
    );
  }
}




